export function Unauthorized() {
  return <>
    <h2>401: Unauthorized</h2>
    <p>This page is for staff only</p>
  </>
}
